import { render } from "./HdCardBody.vue?vue&type=template&id=dd2b58f8"
import script from "./HdCardBody.vue?vue&type=script&lang=js"
export * from "./HdCardBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__